module.exports = __webpack_public_path__ + "static/media/1D.16af9ccb.jpg";